<template>
  <div class="f-column">
    <div
      class="text-medium clr-grey"
      style="margin: 0px 0px 0.25rem"
    >
      {{ $t(`solfigr.icm.prefill`) }}
    </div>
    <div
      class="d-flex f-wrap"
      style="gap: 0.5rem"
    >
      <NavCard
        v-for="item in [
          {
            title: $t('solfigr.icm.browse'),
            sub: $t('solfigr.icm.browse_subtitle'),
            icon: 'mdi-folder-open-outline',
            fn: openIcmStructuresDialog,
            key: 'browse',
          },
          {
            title: $t('solfigr.icm.search'),
            sub: $t('solfigr.icm.search_subtitle'),
            icon: 'mdi-magnify',
            fn: openIcmStructuresSearchDialog,
            key: 'search',
          },
        ]"
        :key="item.key"
        :hasIcon="false"
        :dataTst="`prefill_btn_${item.key}`"
        :hasTitleIcon="true"
        :item
        style="
          --clr-title-hover: var(--clr-white-0);
          --clr-icon-hover: var(--clr-white-0);
          --clr-back: var(--clr-black-1-2);
          --clr-back-hover: var(--clr-black-2);
          min-width: 14rem;
        "
        class="navcard_menu navcard_reversed_l flex-1"
        @click="item.fn"
      />
    </div>
  </div>
</template>

<script>
import NavCard from '@/components/NavCard/NavCard'

export default {
  name: 'SolfigrIcmTournamentStructurePrefillBtns',
  components: {
    NavCard,
  },
  props: {
    namespace: { String, required: true },
  },
  emits: ['update:input'],
  methods: {
    openIcmStructuresDialog() {
      const dialog = `solfigr-icm-structures-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openIcmStructuresSearchDialog() {
      const dialog = `solfigr-icm-structures-search-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
}
</script>
